import './style.scss';

import logo from '@assets/images/logo-web-2.png';
import { ROUTER } from '@core/constants/router.constants';
import { Navigate } from 'react-router-dom';

import { useLogin } from './login.hook';

export const LoginPage: React.FC = () => {
  const { authenticated, email, password, errorMessage, pathname, handleLogin, handleChange } =
    useLogin();

  if (authenticated) {
    return (
      <Navigate
        to={pathname ?? ROUTER.MAIN.INDEX}
        state={{ from: ROUTER.AUTHENTICATION.LOGIN }}
        replace
      />
    );
  }

  return (
    <div className="login__container">
      <div className="login__left">
        <div className="login__form-box">
          <img src={logo} alt="Be Hold" />

          <form method="post" onSubmit={handleLogin}>
            <div className="form-floating mb-3">
              <input
                type="email"
                className="form-control"
                name="emailInput"
                placeholder="name@example.com"
                value={email}
                onChange={handleChange}
                autoComplete="username"
              />
              <label htmlFor="emailInput">E-mail</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="password"
                className="form-control"
                name="passwordInput"
                placeholder="Password"
                value={password}
                onChange={handleChange}
                autoComplete="current-password"
              />
              <label htmlFor="passwordInput">Senha</label>
            </div>

            <div className="d-grid gap-2 mb-3">
              <button className="btn btn-secondary" type="submit">
                Acessar
              </button>
            </div>

            {errorMessage ? (
              <div className="alert alert-danger" role="alert" style={{ maxWidth: '330px' }}>
                {errorMessage}
              </div>
            ) : undefined}
          </form>
        </div>
      </div>
      <div className="login__right"></div>
    </div>
  );
};
